import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({

  selector: 'app-can-dash-full-info',

  templateUrl: './can-dash-full-info.component.html',

  styleUrls: ['../can-dash/can-dash.component.css', './can-dash-full-info.component.css', '../../../styles/styles-dark.css']

})

export class CanDashFullInfoComponent implements OnInit {

  Id!: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {

    this.Id = this.route.parent?.snapshot.params['id']

  }

}
